import { Grid, GridProps } from "@mui/material";
import React from "react";
interface MxFormLayoutProps extends GridProps {
  children: React.ReactNode;
  isEmpty?: boolean;
}
const MxListLayoutMain = (props: MxFormLayoutProps) => {
  return (
    <Grid {...props} container>
      {props.children}
    </Grid>
  );
};

export default MxListLayoutMain;
